import useBaseApiHook, { BASE_API_CONSTANT } from "services/useBaseApiHook"

const REPO_URL = {
    getList: '/wbs-init/paginated',
    getById: '/wbs-init/id',
    saveDraft: '/wbs-init/save',
    create: '/wbs-init/submit',
    update: '/wbs-init/update',
    delete: '/wbs-init/delete',
}

const useWBSInitRepo = (initialLoading = false) => {
    const { isLoading, data, error, executeApi } = useBaseApiHook(initialLoading)

    const getWBSList = async (payload) => {
        return await executeApi(REPO_URL.getList, BASE_API_CONSTANT.METHOD.POST, payload)
    }

    const getWBSById = async (payload) => {
        return await executeApi(REPO_URL.getById, BASE_API_CONSTANT.METHOD.POST, payload)
    }

    const saveDraftWBS = async (payload) => {
        return await executeApi(REPO_URL.saveDraft, BASE_API_CONSTANT.METHOD.POST, payload)
    }

    const submitWBS = async (payload) => {
        return await executeApi(REPO_URL.create, BASE_API_CONSTANT.METHOD.POST, payload)
    }


    return {
        isLoading,
        data,
        error,
        getWBSList,
        getWBSById,
        saveDraftWBS,
        submitWBS
    }
}

export default useWBSInitRepo
